function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Bitstream Vera Sans"
    },
    d: "M 4 2 C 2.9 2 2 2.9 2 4 L 2 18 L 4 18 L 4 4 L 17 4 L 17 2 L 4 2 z M 8 6 C 6.9 6 6 6.9 6 8 L 6 20 C 6 21.1 6.9 22 8 22 L 20 22 C 21.1 22 22 21.1 22 20 L 22 8 C 22 6.9 21.1 6 20 6 L 8 6 z M 8 8 L 20 8 L 20 20 L 8 20 L 8 8 z M 15.90625 8.96875 C 15.105816 8.96875 14.293739 9.3000105 13.6875 9.90625 L 12.28125 11.28125 C 11.97813 11.58437 11.74531 11.934374 11.59375 12.3125 C 11.268538 12.464673 10.948998 12.644752 10.6875 12.90625 L 10.5625 13.03125 L 9.90625 13.6875 C 8.693771 14.899979 8.693771 16.881271 9.90625 18.09375 C 11.118729 19.306229 13.100021 19.306229 14.3125 18.09375 L 15.46875 16.9375 L 15.71875 16.71875 C 16.02187 16.41563 16.25469 16.065626 16.40625 15.6875 C 16.732067 15.542304 17.045347 15.360903 17.3125 15.09375 L 17.875 14.53125 L 18.09375 14.3125 C 19.306229 13.100021 19.306229 11.118729 18.09375 9.90625 C 17.487511 9.3000105 16.706684 8.96875 15.90625 8.96875 z M 15.875 11.03125 C 16.176557 11.03125 16.49374 11.11874 16.6875 11.3125 C 17.075021 11.700021 17.075021 12.518729 16.6875 12.90625 L 16.375 13.21875 C 16.224437 12.87516 15.997292 12.559792 15.71875 12.28125 L 14.28125 13.71875 C 14.668771 14.106271 14.668771 14.893729 14.28125 15.28125 L 12.90625 16.6875 C 12.518729 17.075021 11.700021 17.075021 11.3125 16.6875 L 11.28125 16.65625 C 10.921273 16.258648 10.93431 15.47194 11.3125 15.09375 L 11.625 14.78125 C 11.775563 15.12484 12.002708 15.440208 12.28125 15.71875 L 13.71875 14.28125 C 13.331229 13.893729 13.331229 13.106271 13.71875 12.71875 L 15.09375 11.3125 C 15.28751 11.11874 15.573443 11.03125 15.875 11.03125 z",
    overflow: "visible",
    enableBackground: "accumulate",
    fontFamily: "Bitstream Vera Sans"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCopy);
export default __webpack_public_path__ + "static/media/link-copy.2e77051b64fae71542dadcb121c8fb80.svg";
export { ForwardRef as ReactComponent };